import React from "react";
import SectionList from "../sidebar/SectionList";

export default function LeftSection(props) {
  return <SectionList />;
}
